export const defaultApiState = {
    isLoading: false,
    isUpdated: false,
    error: false,
    errorMessage: null
};
export const defaultInitialState = Object.assign(Object.assign({}, defaultApiState), { data: null });
export const loadingState = Object.assign(Object.assign({}, defaultApiState), { isLoading: true });
export const updatedState = Object.assign(Object.assign({}, defaultApiState), { isUpdated: true });
export const getErrorState = (errorMessage) => (Object.assign(Object.assign({}, defaultApiState), { error: true, errorMessage }));
//# sourceMappingURL=index.js.map